import { cn } from '@heidi/utils';

/** Shared resting/hover treatment for icon-only controls on project composers (+, dictate). */
export const composerToolbarIconButtonClassName = cn(
  'rounded-lg text-text-primary',
  'transition-colors duration-150 ease-out active:scale-95',
  'hover:bg-surface-hover',
  'disabled:active:scale-100',
  '[&_svg]:size-5'
);

/**
 * Labeled toolbar controls (Ask, Sources). Pair with Button size="md" so the
 * hover target matches Ask's height, padding, and radius.
 */
export const composerToolbarLabeledButtonClassName = cn(
  'rounded-lg text-sm font-normal text-text-primary',
  'hover:bg-surface-hover'
);
